import { ApiServiceBase } from './ApiServiceBase';
import { ControllerBase } from './ControllerBase';

export class FormControllerBase<TDataService extends ApiServiceBase> extends ControllerBase
{
  constructor(protected dataService: TDataService)
  {
    super();
  }

}
